import { useCallback, useRef, useState } from "react";

const movementDetectionDistance = 5;

export default function useDrag() {
	const [clicked, setClicked] = useState(false);
	const [dragging, setDragging] = useState(false);
	const position = useRef(0);

	const dragStart = useCallback((evt: React.MouseEvent<Element, MouseEvent>) => {
		position.current = evt.clientX;
		setClicked(true);
	}, []);

	const dragStop = useCallback(
		() =>
			window.requestAnimationFrame(() => {
				setDragging(false);
				setClicked(false);
			}),
		[]
	);

	const dragMove = (evt: React.MouseEvent<Element, MouseEvent>, callback: (posDif: number) => void) => {
		const newDiff = position.current - evt.clientX;
		const isMovementDetected = Math.abs(newDiff) > movementDetectionDistance;

		if (clicked && isMovementDetected) {
			setDragging(true);
		}

		if (dragging && isMovementDetected) {
			position.current = evt.clientX;
			callback(newDiff);
		}
	};

	return {
		dragStart,
		dragStop,
		dragMove,
		dragging,
		position,
		setDragging,
	};
}
